export const QUERY_CURRENT_USER = 'currentUser'
export const QUERY_CURRENT_USER_GROUPS = 'currentUserGroups'
export const QUERY_CURRENT_USER_INSTITUTIONS = 'currentUserInstitutions'
export const QUERY_CURRENT_USER_TASKS = 'currentUserTasks'
export const QUERY_CURRENT_USER_SHORTCUTS = 'currentUserShortcuts'
export const QUERY_CURRENT_USER_GROUPS_SHORTCUTS = 'currentUserGroupsShortcuts'
